"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeatIndustry = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var MeatIndustry = (function (_super) {
    __extends(MeatIndustry, _super);
    function MeatIndustry() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MEAT_INDUSTRY,
            tags: [Tags_1.Tags.BUILDING],
            cost: 5,
            metadata: {
                cardNumber: 'X25',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you gain an animal to ANY CARD, gain 2 M€.', function (eb) {
                        eb.animals(1).asterix().startEffect.megacredits(2);
                    });
                }),
            },
        }) || this;
    }
    MeatIndustry.prototype.play = function () {
        return undefined;
    };
    return MeatIndustry;
}(Card_1.Card));
exports.MeatIndustry = MeatIndustry;
